import Container from '@components/container'
import {
  StyleAuthActionWrapper,
  StyleAuthRow,
  StyleAuthWrapper,
} from '../style'
import AuthBanner from '../components/banner'
import AuthHeader from '../components/header'
import AuthFooter from '../components/footer'
import { Formik, Form } from 'formik'
import Column from '@components/column'
import Fields from '@components/fields'
import Button from '@components/button'
import { useLocation } from 'react-router-dom'
import { AuthSchema } from '@validations'
import { useNavigate } from 'react-router-dom'
import { useState } from 'react'
import { Otp } from '@apis'
const EmailPage = () => {
  const { state } = useLocation()
  const navigate = useNavigate()
  const [loading, setLoading] = useState<boolean>(false)
  const submitHandler = async (values) => {
    setLoading(true)
    await Otp.send({
      data: {
        countryCode: state?.countryCode,
        phoneNo: values.email,
        purpose: state?.purpose,
      },
    })
      .then((resp) => {
        navigate('/verify', {
          state: {
            ...state,
            ...values,
            token: resp?.token,
          },
        })
      })
      .catch(() => {})
    setLoading(false)
  }
  return (
    <StyleAuthWrapper>
      <Container>
        <StyleAuthRow>
          <AuthBanner />
          <StyleAuthActionWrapper>
            <AuthHeader
              title="Create a Account to Continue with"
              tag="Supachar"
            />
            <Formik
              initialValues={{
                email: '',
                purpose: state?.purpose,
              }}
              onSubmit={submitHandler}
              validationSchema={AuthSchema.userEmailValidationsSchema}
            >
              {({ handleSubmit }) => {
                return (
                  <Form onSubmit={handleSubmit}>
                    <Column rowGap={20}>
                      <Fields.Input
                        name="email"
                        label="Email Address"
                        placeholder="Email Address"
                      />

                      <Column styleColumn="margin-top:30px;">
                        <AuthFooter
                          title="I am already Registered!"
                          linkTitle="Login"
                          to="/login"
                        />
                        <Button
                          type="submit"
                          title="Send"
                          styleButton="width:100%"
                          height={40}
                          loading={loading}
                        />
                      </Column>
                    </Column>
                  </Form>
                )
              }}
            </Formik>
          </StyleAuthActionWrapper>
        </StyleAuthRow>
      </Container>
    </StyleAuthWrapper>
  )
}

export default EmailPage
